module.exports = __webpack_public_path__ + "static/media/eight.bf3b76c3.jpg";